/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Location Bizos
 */

import { ZOOM_DEFAULT, getQueryBounds } from '@zcode/nr-utils'
import type { SaveSearchLocation, SaveSearchLocationBox } from '@zcode/state-type'

// TODO: fix this, bizo should not have app-specific value

export const EMPTY_BOUNDS = {
  minLng: null,
  maxLng: null,
  minLat: null,
  maxLat: null,
} as const satisfies SaveSearchLocationBox

export const EMPTY_LOCATION = {
  // coordinates information
  box: EMPTY_BOUNDS,
  lat: null,
  lng: null,
  url: null,
  zoom: ZOOM_DEFAULT,
  // zumper/padmaper specific location name
  hoodName: '',
  cityName: '',
  stateName: '',
  // flags that client use to take an appropriate actions
  fromAutocomplete: false,
  fromBackButton: false,
  fromClient: false,
  fromLocateMe: false,
  fromCluster: false,
  fromMapInteraction: false,
  fromNoListables: false,
  preventUrlUpdate: false,
  missing: false,
} as const satisfies SaveSearchLocation

export const Location = {
  fromJS: (
    data: Omit<SaveSearchLocation, 'box'> & {
      readonly box: `${number},${number},${number},${number}` | SaveSearchLocation['box']
    }
  ): SaveSearchLocation => {
    const box = typeof data.box === 'string' ? getQueryBounds(data.box) : data.box
    return {
      box,
      lat: data.lat,
      lng: data.lng,
      url: data.url,
      zoom: data.zoom,
      hoodName: data.hoodName,
      cityName: data.cityName,
      stateName: data.stateName,
      fromAutocomplete: data.fromAutocomplete,
      fromBackButton: data.fromBackButton,
      fromClient: data.fromClient,
      fromCluster: data.fromCluster,
      fromLocateMe: data.fromLocateMe,
      fromMapInteraction: data.fromMapInteraction,
      fromNoListables: data.fromNoListables,
      preventUrlUpdate: data.preventUrlUpdate,
      missing: data.missing,
    }
  },
}
